<template>
  <!-- BSL-URN §4.3 «Örnekle başla» önizlemesi. İçerik ve silinecekler BE'de hesaplanır
       (GetBaslarkenOrnek); FE yalnız fiyatı değiştirir (Anahtar → Fiyat).
       BSL-RDV §4: RDV-TIP'te randevu tipleri + süre (Anahtar → Sure), «Pasife alınacak».
       BSL-STU §4: Studio paketinde (102) ders hakkı ve gün de değiştirilebilir (Seans/Gun).
       BSL-DYT §4: Diyet paketinde (101) yalnız gün.
       BSL-DST §4: DST-KATEGORI'de yardım masası kategorileri + sorumlu (Anahtar → Kullanici).
       BSL-BLG §4: BLG-KOLEKSIYON'da tek koleksiyon; eklenince detay «Siteme Ekle» sekmesinde açılır. -->
  <Dialog
    :visible="!!bsl.ornekMaddeKod"
    modal
    :draggable="false"
    header="Örnekle başla"
    :style="{ width: '40rem' }"
    :breakpoints="{ '640px': '100vw' }"
    @update:visible="(v) => { if (!v) kapat(); }"
  >
    <div v-if="yukleniyor" class="py-6 text-center text-sm text-surface-500">Yükleniyor…</div>
    <div v-else-if="plan" class="flex flex-col gap-4">
      <section v-if="plan.Koleksiyon">
        <h3 class="font-semibold text-sm mb-2 text-surface-800 dark:text-surface-100">Eklenecek koleksiyon</h3>
        <p class="text-sm">
          <span class="font-medium" :class="{ 'line-through text-surface-400': plan.Koleksiyon.Var }">{{ plan.Koleksiyon.Ad }}</span>
          <span class="text-surface-500"> · Yayındaki tüm yazılar · yayında</span>
          <span v-if="plan.Koleksiyon.Var" class="text-xs text-surface-500 ml-2">zaten var, atlanır</span>
        </p>
        <p class="text-xs text-surface-500 mt-2">Yayındaki bütün yazılarınızı gösteren bir sayfa açılır. Bağlantısını ve sitenize gömme kodunu bir sonraki ekranda alırsınız.</p>
      </section>

      <section v-if="ymKategoriler.length">
        <h3 class="font-semibold text-sm mb-2 text-surface-800 dark:text-surface-100">Eklenecek destek kategorileri</h3>
        <ul class="flex flex-col gap-1.5">
          <li v-for="k in ymKategoriler" :key="k.Anahtar" class="flex flex-wrap items-center gap-x-3 gap-y-1">
            <span class="text-sm font-medium min-w-[9rem]" :class="{ 'line-through text-surface-400': k.Var }">{{ k.Ad }}</span>
            <span v-if="k.Var" class="text-xs text-surface-500">zaten var, atlanır</span>
            <Select
              v-else
              v-model="sorumlular[k.Anahtar]"
              :input-id="'bsl-sorumlu-' + k.Anahtar"
              :options="plan.Kullanicilar || []"
              option-label="AdSoyad"
              option-value="Kullanici_rowid"
              :aria-label="k.Ad + ' sorumlusu'"
              class="ml-auto w-48"
            />
          </li>
        </ul>
        <p class="text-xs text-surface-500 mt-2">Sorumlu, o kategoriye gelen çağrıyı ilk görendir; sonra Kategori Listesi'nden değiştirebilirsiniz.</p>
      </section>

      <section v-if="tipler.length">
        <h3 class="font-semibold text-sm mb-2 text-surface-800 dark:text-surface-100">Eklenecek randevu tipleri</h3>
        <ul class="flex flex-col gap-1.5">
          <li v-for="t in tipler" :key="t.Anahtar" class="flex flex-wrap items-center gap-x-3 gap-y-1">
            <span class="text-sm font-medium min-w-[9rem]" :class="{ 'line-through text-surface-400': t.Var }">{{ t.Ad }}</span>
            <span v-if="t.Var" class="text-xs text-surface-500">zaten var, atlanır</span>
            <InputNumber
              v-else
              v-model="sureler[t.Anahtar]"
              :input-id="'bsl-sure-' + t.Anahtar"
              :min="5"
              :max="600"
              :use-grouping="false"
              suffix=" dk"
              placeholder="Süre"
              highlight-on-focus
              :aria-label="t.Ad + ' süresi'"
              input-class="w-24 text-right"
              class="ml-auto"
            />
          </li>
        </ul>
        <p class="text-xs text-surface-500 mt-2">Süreyi boş bırakırsanız tip şubenin randevu süresini kullanır; sonra Randevu Tipleri'nden değiştirebilirsiniz.</p>
      </section>

      <section v-if="plan.Pasife && plan.Pasife.length" class="rounded-lg zemin-uyari p-3">
        <h3 class="font-semibold text-sm mb-1 renk-uyari">Pasife alınacak</h3>
        <p class="text-sm">
          Hiç randevuya bağlanmamış hazır tip: {{ plan.Pasife.map((p) => p.Ad).join(", ") }}. Silinmez, yeni randevuda seçilemez.
        </p>
      </section>

      <section v-if="agac.length">
        <h3 class="font-semibold text-sm mb-2 text-surface-800 dark:text-surface-100">Eklenecek</h3>
        <div v-for="k in agac" :key="k.ad" class="mb-3">
          <p class="text-sm font-semibold"><i class="pi pi-folder mr-1 text-surface-400" aria-hidden="true"></i>{{ k.ad }}</p>
          <div v-for="a in k.altlar" :key="a.ad" class="ml-4 mt-1">
            <p class="text-sm text-surface-600 dark:text-surface-300">{{ a.ad }}</p>
            <ul class="ml-4 mt-1 flex flex-col gap-1.5">
              <li v-for="u in a.urunler" :key="u.Anahtar" class="flex flex-wrap items-center gap-x-3 gap-y-1">
                <span class="text-sm font-medium min-w-[9rem]" :class="{ 'line-through text-surface-400': u.Var }">{{ u.Ad }}</span>
                <span class="text-xs text-surface-500">{{ u.TurAd }} · {{ u.Birim }}<template v-if="!paketDuzenlenir(u)"><template v-if="u.PaketSeans"> · {{ u.PaketSeans }} ders</template><template v-if="u.PaketGun"> · {{ u.PaketGun }} gün</template></template></span>
                <span v-if="u.Var" class="text-xs text-surface-500">zaten var, atlanır</span>
                <template v-if="paketDuzenlenir(u)">
                  <InputNumber
                    v-if="!paket[u.Anahtar].diyet"
                    v-model="paket[u.Anahtar].Seans"
                    :input-id="'bsl-seans-' + u.Anahtar"
                    :min="1"
                    :max="999"
                    :use-grouping="false"
                    suffix=" ders"
                    placeholder="Ders"
                    highlight-on-focus
                    :aria-label="u.Ad + ' ders hakkı'"
                    input-class="w-20 text-right"
                  />
                  <InputNumber
                    v-model="paket[u.Anahtar].Gun"
                    :input-id="'bsl-gun-' + u.Anahtar"
                    :min="paket[u.Anahtar].diyet ? 1 : 0"
                    :max="3650"
                    :use-grouping="false"
                    suffix=" gün"
                    :placeholder="paket[u.Anahtar].diyet ? 'Gün' : 'Süresiz'"
                    highlight-on-focus
                    :aria-label="u.Ad + ' geçerlilik günü'"
                    input-class="w-20 text-right"
                  />
                </template>
                <!-- BSL-D3 B-20: fiyat her satırda; paket satırında ders/gün alanlarından sonra -->
                <InputNumber
                  v-model="fiyatlar[u.Anahtar]"
                  :input-id="'bsl-fiyat-' + u.Anahtar"
                  mode="decimal"
                  locale="tr-TR"
                  :min="0"
                  :max-fraction-digits="2"
                  suffix=" TL"
                  placeholder="Fiyat"
                  highlight-on-focus
                  :aria-label="u.Ad + ' fiyatı'"
                  input-class="w-28 text-right"
                  class="ml-auto"
                />
              </li>
            </ul>
          </div>
        </div>
        <p class="text-xs text-surface-500">Fiyatı boş bırakırsanız ürün fiyatsız açılır; sonra Ürün Listesi'nden değiştirebilirsiniz.</p>
      </section>

      <section v-if="plan.Silinecek && plan.Silinecek.length" class="rounded-lg zemin-uyari p-3">
        <h3 class="font-semibold text-sm mb-1 renk-uyari">Kaldırılacak</h3>
        <p class="text-sm">
          Hiç ürüne bağlanmamış hazır kategoriler:
          {{ plan.Silinecek.map((k) => k.Ad + " (" + k.AltKategoriSayisi + " alt kategori)").join(", ") }}.
        </p>
      </section>
    </div>

    <template #footer>
      <Button label="Vazgeç" severity="secondary" text :disabled="kaydediliyor" @click="kapat" />
      <Button label="Ekle" :loading="kaydediliyor" :disabled="!plan || !eklenecekVar" @click="ekle" />
    </template>
  </Dialog>
</template>

<script>
import { bsl, durumYukle, turIste } from "@/baslarken/durum";

export default {
  name: "OrnekOnizleme",
  data() {
    return { bsl, plan: null, fiyatlar: {}, sureler: {}, paket: {}, sorumlular: {}, yukleniyor: false, kaydediliyor: false };
  },
  computed: {
    agac() {
      const kats = [];
      for (const u of (this.plan && this.plan.Urunler) || []) {
        let k = kats.find((x) => x.ad === u.Kategori);
        if (!k) kats.push((k = { ad: u.Kategori, altlar: [] }));
        let a = k.altlar.find((x) => x.ad === u.AltKategori);
        if (!a) k.altlar.push((a = { ad: u.AltKategori, urunler: [] }));
        a.urunler.push(u);
      }
      return kats;
    },
    tipler() {
      return (this.plan && this.plan.Tipler) || [];
    },
    ymKategoriler() {
      return (this.plan && this.plan.YmKategoriler) || [];
    },
    eklenecekVar() {
      return ((this.plan && this.plan.Urunler) || []).some((u) => !u.Var) || this.tipler.some((t) => !t.Var) || this.ymKategoriler.some((k) => !k.Var) || !!(this.plan && this.plan.Koleksiyon && !this.plan.Koleksiyon.Var);
    },
  },
  watch: {
    "bsl.ornekMaddeKod"(kod) {
      if (kod) this.yukle(kod);
    },
  },
  methods: {
    paketDuzenlenir(u) {
      return !u.Var && !!this.paket[u.Anahtar];
    },
    yukle(kod) {
      this.plan = null;
      this.yukleniyor = true;
      this.$Servis("GET", "GetBaslarkenOrnek?MaddeKod=" + encodeURIComponent(kod), "")
        .then((res) => {
          if (res.status === 200 && res.data) {
            this.plan = res.data;
            const f = {};
            // PrimeVue InputNumber: boş = null (0 ya da "" rakamı kaybettirir).
            (res.data.Urunler || []).forEach((u) => { f[u.Anahtar] = u.Fiyat != null ? Number(u.Fiyat) : null; });
            this.fiyatlar = f;
            const p = {};
            (res.data.Urunler || []).forEach((u) => {
              if (u.TurAd === "Studio paketi") p[u.Anahtar] = { Seans: u.PaketSeans || null, Gun: u.PaketGun || null };
              // BSL-DYT: diyet paketinde ders hakkı yok, yalnız gün (plan uzunluğu).
              else if (u.TurAd === "Diyet paketi") p[u.Anahtar] = { Gun: u.PaketGun || null, diyet: true };
            });
            this.paket = p;
            const s = {};
            (res.data.Tipler || []).forEach((t) => { s[t.Anahtar] = t.SureDakika != null ? Number(t.SureDakika) : null; });
            this.sureler = s;
            const so = {};
            (res.data.YmKategoriler || []).forEach((k) => { so[k.Anahtar] = res.data.VarsayilanSorumlu || null; });
            this.sorumlular = so;
          } else if (res.status === 999) {
            this.$toast.add({ severity: "warn", summary: "Uyarı", detail: res.data, life: 4000 });
            this.kapat();
          } else {
            this.$toast.add({ severity: "error", summary: "Hata", detail: "Örnek yüklenemedi.", life: 4000 });
            this.kapat();
          }
        })
        .catch(() => this.kapat())
        .finally(() => { this.yukleniyor = false; });
    },
    ekle() {
      this.kaydediliyor = true;
      const Fiyatlar = Object.keys(this.fiyatlar).map((Anahtar) => ({
        Anahtar,
        Fiyat: this.fiyatlar[Anahtar] == null ? "" : String(this.fiyatlar[Anahtar]),
        Seans: this.paket[Anahtar] && this.paket[Anahtar].Seans != null ? String(this.paket[Anahtar].Seans) : "",
        Gun: this.paket[Anahtar] ? String(this.paket[Anahtar].Gun || 0) : "",
      }));
      const Sureler = Object.keys(this.sureler).map((Anahtar) => ({
        Anahtar,
        Sure: this.sureler[Anahtar] == null ? "" : String(this.sureler[Anahtar]),
      }));
      const Sorumlular = Object.keys(this.sorumlular).map((Anahtar) => ({ Anahtar, Kullanici: Number(this.sorumlular[Anahtar]) || 0 }));
      this.$Servis("POST", "SetBaslarkenOrnek", { MaddeKod: bsl.ornekMaddeKod, Fiyatlar, Sureler, Sorumlular })
        .then((res) => {
          if (res.status === 200 && res.data) {
            const n = res.data.EklenenUrun || 0;
            const s = res.data.SilinenKategori || 0;
            const detay = res.data.EklenenKoleksiyon != null
              ? (res.data.EklenenKoleksiyon ? "«Blog» koleksiyonu açıldı." : "Koleksiyon zaten var.")
              : res.data.EklenenKategori != null
              ? res.data.EklenenKategori + " destek kategorisi eklendi."
              : res.data.EklenenTip != null
              ? res.data.EklenenTip + " randevu tipi eklendi" + (res.data.PasifeAlinan ? ", «Genel Görüşme» pasife alındı." : ".")
              : n + " ürün eklendi" + (s ? ", " + s + " hazır kategori kaldırıldı." : ".");
            this.$toast.add({ severity: "success", summary: "Başarılı", detail: detay, life: 4000 });
            // BSL-D3 B-24: aynı adlı ürünsüz ders tipi pakete bağlandıysa uyarı
            if (res.data.DersTipNotu) this.$toast.add({ severity: "warn", summary: "Uyarı", detail: res.data.DersTipNotu, life: 6000 });
            bsl.ornekSayac++;
            this.kapat();
            durumYukle(true);
            // BSL-BLG §4: yeni koleksiyonun «Siteme Ekle» sekmesi + turu
            if (res.data.BlogKoleksiyon_rowid) {
              turIste("koleksiyonSiteme");
              this.$router.push({ path: "/blog/koleksiyon/" + res.data.BlogKoleksiyon_rowid });
            }
          } else if (res.status === 999) {
            this.$toast.add({ severity: "warn", summary: "Uyarı", detail: res.data, life: 4000 });
          } else {
            this.$toast.add({ severity: "error", summary: "Hata", detail: "Örnek eklenemedi.", life: 4000 });
          }
        })
        .catch(() => {})
        .finally(() => { this.kaydediliyor = false; });
    },
    kapat() {
      bsl.ornekMaddeKod = null;
    },
  },
};
</script>
